import React from 'react'
import clsx from 'clsx'
import { ReactComponent as IconPreloader } from 'images/preloader.svg';
import styles from './Preloader.module.scss';

function Preloader({ className, inline }: {
  className?: string,
  inline?: boolean,
}) {
  return (
    <div
      className={clsx(
        styles.container,
        inline && styles.containerInline,
        className,
      )}
    >
      <IconPreloader className={styles.preloader} />
    </div>
  )
}

export default Preloader
